import React, { useContext } from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { HashLink as RouterLink } from 'react-router-hash-link';

import { UpdateRequiredContext } from 'containers/UpdateRequiredContext';

type Props = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.ComponentType<any>;
  to?:
    | string
    | {
        pathname: string;
        state?: Record<string, unknown>;
      };
} & Record<string, unknown>;

export function BaseLink({ component, to, ...props }: Props) {
  const Component = component;

  const isStateless =
    typeof to === 'string' || (typeof to === 'object' && !to.state);

  const updateRequired = useContext(UpdateRequiredContext);

  if (updateRequired && isStateless) {
    /* eslint-disable jsx-a11y/anchor-has-content */
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | { pathname: string; state?: Record<... Remove this comment to see the full error message
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <a href={to} {...props} />;
    /* eslint-enable jsx-a11y/anchor-has-content */
  }

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component to={to} {...props} />;
}

export function NavLink(props: Omit<Props, 'component'>) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <BaseLink component={RouterNavLink} {...props} />;
}

export function Link(props: Omit<Props, 'component'>) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <BaseLink component={RouterLink} {...props} />;
}
